import { OverlayContainer } from '@angular/cdk/overlay';
import { ChangeDetectionStrategy, Component, HostBinding, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { getInitialState } from './initial-state';
import { ThemingService } from './theming.service';
import { WebNavbarComponent } from './web-navbar/web-navbar.component';

const oca = getInitialState();

@Component({
  selector: 'web-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [WebNavbarComponent, RouterOutlet],
})
export class AppComponent implements OnInit {
  private themingService = inject(ThemingService);
  private overlayContainer = inject(OverlayContainer);

  @HostBinding('class') public cssClass = 'light-theme';
  private translate = inject(TranslateService);

  ngOnInit() {
    this.translate.use(typeof oca === 'undefined' ? 'nl' : oca.mainLanguage);
    this.themingService.theme.subscribe(theme => {
      const overlayClassList = this.overlayContainer.getContainerElement().classList;
      overlayClassList.remove(this.cssClass);
      this.cssClass = theme;
      overlayClassList.add(theme);
    });
  }
}
